import type { NetSuiteIntegrationConfiguration } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { NetSuiteConfigurationFormValues } from '../NetSuiteConfigurationFormSchema';

export function getNetSuiteIntegrationSettings(configuration: NetSuiteConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.netSuite,
    integrationConfiguration: mapFormValuesToNetSuiteSettings(configuration),
  };
}

function mapFormValuesToNetSuiteSettings(
  formValues: NetSuiteConfigurationFormValues,
): DeepPartial<NetSuiteIntegrationConfiguration> {
  return {
    defaultReceivableAccount: formValues.defaultReceivableAccount,
    defaultProduct: formValues.defaultProduct ?? undefined,
    taxExportStrategy: formValues.taxExportStrategy,
    accountTaxItem: formValues.accountTaxItem ?? undefined,
    taxItemBySubsidiaryId: formValues.taxItemBySubsidiaryId,
    autoExportInvoices: formValues.autoExportInvoices,
    autoExportCreditMemos: formValues.autoExportCreditMemos,
    autoExportCustomers: formValues.autoExportCustomers,
    invoiceNumberSyncStrategy: formValues.invoiceNumberSyncStrategy,
    invoicePaymentStatusSyncStrategy: formValues.invoicePaymentStatusSyncStrategy,
    summarizeLineItemsByProductId: formValues.summarizeLineItemsByProductId,
    overrideLineItemQuantity: formValues.overrideLineItemQuantity,
    linkInvoiceToSalesOrder: formValues.linkInvoiceToSalesOrder,
    defaultStripeDepositToAccountId: formValues.defaultStripeDepositToAccountId ?? '',
  };
}
